import { create } from 'zustand'

const useHomeStore = create((set, get) => ({
    isSubBarSticky: false,
    setIsSubBarSticky: (value) => set((state) => {
        return { isSubBarSticky: value }
    }),
}))

export default useHomeStore;